/* eslint-disable @typescript-eslint/require-await */
import { useCallback } from 'react';

import { Link, LinkSize, PrintIcon } from '@dreryk/react-components';

import { printPrescriptionPackage } from '~libs.shared.prescription';

import { prescriptionsTranslationKeys } from '../../../../../translations';

type PrescriptionPackagePrintLinkProps = {
   readonly prescriptionPackageId: number;
};

export const PrescriptionPackagePrintLink = (props: PrescriptionPackagePrintLinkProps): JSX.Element => {
   const handleClick = useCallback(async () => {
      return printPrescriptionPackage(props.prescriptionPackageId);
   }, [props.prescriptionPackageId]);

   return (
      <Link
         testId={'prescriptionPackagePrintLink'}
         label={prescriptionsTranslationKeys.prescription.print}
         onClick={handleClick}
         icon={<PrintIcon />}
         size={LinkSize.NORMAL}
      />
   );
};
